import { t } from "@lingui/macro";
import * as React from "react";
import { Path, G, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const CalendarArrowIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Calendar Arrow`} {...props}>
    <G
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      clipPath="url(#a)"
      fill="none"
    >
      <Path d="M15 7V3.444C15 2.647 14.304 2 13.444 2H2.556C1.696 2 1 2.647 1 3.444v10.112C1 14.353 1.696 15 2.556 15H7M11 1v3M5 1v3M1 7h14M13 14l2-2-2-2M15 12H9" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="none" d="M0 0h16v16H0z" />
      </ClipPath>
    </Defs>
  </Icon>
);
